import { Grid, Typography, useMediaQuery } from "@material-ui/core";
import manlaptop from "assets/images/man_with_laptop.svg";
import { DefaultInfo } from "components/NothingRight";
import { Slider } from "components/Slider/Slider";
import { theme } from "config/theme";
import useText from "constants/text";
import { ClientRefsAddress } from "generated/graphql";
import React from "react";
import { Button } from "ui/Button";
import AddAddressForm from "./component/addAddress";
import { AddressTable } from "./component/addressTable";
import { useAddressActions } from "./data";
import { useStyles } from "./styles";



export const UserAddress = () => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const styles = useStyles();
  const { text } = useText();
  const [openDrawer, setOpenDrawer] = React.useState(false);
 const [isEdited, setIsedited] = React.useState(false);
  const [addressToUpdate, setAddressToUpdate] = React.useState<ClientRefsAddress>(null);
  const [addressToDelete, setAddressToDelete] = React.useState<ClientRefsAddress>(null);

  
  const onAddAddress = () => {
  setOpenDrawer(true);
  setIsedited(false);
  }
  const handleCancel = () => {
    setOpenDrawer(false);
    setIsedited(false);
    setAddressToDelete(null);
    setAddressToUpdate(null)
  };
  const handleEdit = (props: ClientRefsAddress) => {
    setAddressToUpdate(props);
    setOpenDrawer(true);
    setIsedited(true);

  };
  const addressActions = useAddressActions(text);

   const onRowMenuClick = (key: string, row: any) => {
     switch (key) {
       case "edit":
         return handleEdit(row);
       case "delete":
         return setAddressToDelete(row);
       // no default
     }
   };

  return (
    <div className={styles.root}>
      <div
        className={styles.left}
        style={{
          width: isSmallScreen ? "100%" : "70%",
        }}
      >
        <Grid container direction="row" className={styles.header}>
          <Grid item xs={6} md={2}>
            <Button color="primary" variant="contained" className={styles.addButton} onClick={onAddAddress}>
              {text.all.add_new_address}
            </Button>
          </Grid>
          {!isSmallScreen && (
            <Grid item xs={7}>
              <Typography className={styles.tag} variant="h3">
                {text.all.set_up_and_have_a_global_view_on}&nbsp;
                <b>{text.all.your_different_point_of_sale}</b>
              </Typography>
            </Grid>
          )}

          <Grid item xs={6} md={2} className={styles.headerIcon}>
            <img
              src={manlaptop}
              width={isSmallScreen ? "100px" : "120px"}
              css={`
                margin-top: -10px;
              `}
              alt="man with laptop"
            />
          </Grid>
        </Grid>
        <AddressTable
          onRowMenuClick={onRowMenuClick}
          multipleActions={addressActions}
          addressToDelete={addressToDelete}
        />
        {isSmallScreen && (
          <Slider openDrawer={openDrawer} handleClose={() => setOpenDrawer(false)}>
            <AddAddressForm isEdited={isEdited} handleCancel={handleCancel} addressToUpdate={addressToUpdate} />
          </Slider>
        )}
      </div>

      <div className={styles.right}>
        {openDrawer ? (
          <AddAddressForm isEdited={isEdited} handleCancel={handleCancel} addressToUpdate={addressToUpdate} />
        ) : (
          <DefaultInfo />
        )}
      </div>
    </div>
  );
}

export default UserAddress
